import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { LoginPanelService } from '@core/services/login-panel.service';
import { PlatformService } from '@core/services/platform.service';
import { Subject } from 'rxjs';
import { delay, filter, takeUntil } from 'rxjs/operators';

@Component({
    selector: 'app-login-panel-trigger',
    template: '',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: true
})
export class LoginPanelTriggerComponent implements OnInit {
    private unsubscribe: Subject<void> = new Subject<void>();

    constructor(
        private loginPanelService: LoginPanelService,
        private platformService: PlatformService,
        private router: Router
    ) {}

    ngOnInit(): void {
        this.router.events
            .pipe(
                filter(event => event instanceof NavigationEnd && this.platformService.isBrowser),
                delay(500), // Boot time only do this on load
                takeUntil(this.unsubscribe)
            )
            .subscribe(() => {
                if (this.loginPanelService.strHasPanelTrigger(this.router.url)) {
                    this.loginPanelService.triggerClubOrPanel();
                }
                this.unsubscribe.next();
                this.unsubscribe.complete();
            });
    }
}
